module.exports = __webpack_public_path__ + "static/Header-3a9a7d17b2c0eea27340f49eef60b7f4.jpg";